import { NavDrawerBody, NavDrawerHeader, NavItem, Subtitle2 } from '@fluentui/react-components'
import { DarkTheme24Regular } from '@fluentui/react-icons'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNotification, useTheme } from '../../../hooks'
import { useSettingsStyles } from '../settingsStyles'

type ThemeSubmenuProps = {
  setCurrentTheme: React.Dispatch<'light' | 'dark'>
  onClose?: () => void
}
const ThemeSubmenu = ({ setCurrentTheme, onClose }: ThemeSubmenuProps) => {
  const styles = useSettingsStyles()
  const { t } = useTranslation()
  const { setThemeMode } = useTheme()
  const { notify } = useNotification()
  const [renderKey, setRenderKey] = useState(0)

  const updateTheme = (theme: 'light' | 'dark') => {
    setThemeMode(theme)
    setCurrentTheme(theme)
    // Safari shows both options selected after theme change. This forces a re-render.
    setRenderKey((prev) => prev + 1)
    notify({ isSuccess: true, text: t('settings.appearanceUpdated'), position: 'top' })
    onClose?.()
  }

  return (
    <>
      <NavDrawerHeader className={styles.submenuHeader}>
        <DarkTheme24Regular />
        <Subtitle2 as="h2">{t('settings.appearance')}</Subtitle2>
      </NavDrawerHeader>
      <NavDrawerBody key={`theme-${renderKey}`}>
        <NavItem value="light" onClick={() => updateTheme('light')}>
          <p className={styles.itemText}>{t('theme.light')}</p>
        </NavItem>
        <NavItem value="dark" onClick={() => updateTheme('dark')}>
          <p className={styles.itemText}>{t('theme.dark')}</p>
        </NavItem>
      </NavDrawerBody>
    </>
  )
}

export { ThemeSubmenu }
